import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import {
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  Button,
  FormElement,
  InputText,
  MODAL_SIZE_XXL
} from 'mailup-web-components'
import './DynamicFieldsModal.scss'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { modalDefaultFields } from '../../../recoil/state/modal'
import {
  getDynamicFieldsCallback,
  getDynamicFieldsListValueCallback,
  saveDinamicFieldCallback
} from '../../../recoil/callbacks/callbacks'
import { dynamicFiledListState } from '../../../recoil/state/list'
import { messageState } from '../../../recoil/state/message'

const DynamicFieldsModal = () => {
  const intl = useIntl()
  const [open, setOpen] = useRecoilState(modalDefaultFields)
  const [{ fields }, setFields] = useRecoilState(messageState)
  const getDFCallback = useRecoilCallback(getDynamicFieldsCallback, [])
  const getDFListValueCallback = useRecoilCallback(
    getDynamicFieldsListValueCallback,
    []
  )
  const saveDFCallback = useRecoilCallback(saveDinamicFieldCallback, [])
  const { dynamicFiledList } = useRecoilValue(dynamicFiledListState)

  const handleClose = () => {
    setOpen(false)
  }

  const handleSaveAndClose = () => {
    setOpen(false)
    saveDFCallback()
  }

  const handleChange = (e, prevObj) => {
    const oldIFields = fields.map(e => e)
    const value =
      e.target.value.length > 100
        ? e.target.value.substring(0, 100)
        : e.target.value
    const index = oldIFields.findIndex(fe => fe.Id === prevObj.Id)
    const currentObj = {
      Id: prevObj.Id,
      Value: value,
      Description: prevObj.Description
    }
    if (index > -1) {
      oldIFields[index] = currentObj
    } else {
      oldIFields.push(currentObj)
    }
    setFields(prev => ({
      ...prev,
      isDirty: true,
      fields: oldIFields
    }))
  }

  useEffect(() => {
    if (dynamicFiledList.length === 0 && open) {
      getDFCallback()
      getDFListValueCallback()
    }
  }, [dynamicFiledList, open])

  return (
    <Modal
      show={open}
      showClose
      closeOnOverlayClick
      onClose={handleClose}
      size={MODAL_SIZE_XXL}
      scrollable
      className='c-modal__scrollable'
      data-mu-test='overview-message__modal-dynamic-field'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ModalDynamicFields.Titolo'
        })}
      />
      <ModalBody>
        <div className='c-modal__modal-container'>
          {intl.formatMessage({
            id: 'Load.ModalDynamicFields.Descrizione'
          })}
          {dynamicFiledList.length === 0 && <div className='is-loading' />}
          {dynamicFiledList.length > 0 && (
            <div className='c-modal__table-container'>
              <div>
                <table className='c-modal__data-table'>
                  <tbody>
                    <tr className='c-modal__header_style'>
                      <td className='c-modal__header_style-col'>
                        {intl.formatMessage({
                          id: 'Load.ModalDynamicFields.FieldName'
                        })}
                      </td>
                      <td className='c-modal__header_style-col'>
                        {intl.formatMessage({
                          id: 'Load.ModalDynamicFields.FieldDefaultValue'
                        })}
                      </td>
                    </tr>
                    {dynamicFiledList.map((e, i) => {
                      const val = fields.find(fe => fe.Id === e.Id)
                      return (
                        <tr key={e.Id} className='c-modal__tr'>
                          <td className='c-modal__td'>
                            <FormElement
                              labelFor={e.Id + ''}
                              label={e.Description}
                            />
                          </td>
                          <td className='c-modal__td'>
                            <InputText
                              placeholder=''
                              onChange={evt => handleChange(evt, e)}
                              value={val ? val.Value : ''}
                              data-mu-test={'input-' + e.Id}
                              name={e.Id + ''}
                            />
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <div /> {/* last child 30px  */}
            </div>
          )}
        </div>
      </ModalBody>

      <ModalFoot>
        <Button
          onClick={handleClose}
          kind='secondary'
          data-mu-test='overview-message__modal-dynamic-field-button-cancel'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button onClick={handleSaveAndClose} kind='primary'>
          {intl.formatMessage({ id: 'Load.MailupCommon.Save' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default DynamicFieldsModal
